export default "__VITE_ASSET__b4eiYiOd__"